export default __webpack_public_path__ + "static/media/requirements_bg.dc84ef18.png";